import { uitexts } from '@/helpers/uitexts';

export default {
    uiText(id) {
        return uitexts[id];
    }
};
